import 'hammerjs';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatIconModule, MatSnackBarModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import Api from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateModule } from '@ngx-translate/core';
import { UserApiService } from 'app/api/user.api.service';
import { AppComponent } from 'app/app.component';
import { AppSyncErrorService } from 'app/appsync-error.service';
import { AuthModule } from 'app/auth/auth.module';
import { AuthService } from 'app/auth/auth.service';
import { fuseConfig } from 'app/fuse-config';
import { LayoutModule } from 'app/layout/layout.module';
import { MainModule } from 'app/main/main.module';
import { AmplifyAngularModule, AmplifyModules, AmplifyService } from 'aws-amplify-angular';
import { MarkdownModule } from 'ngx-markdown';

import { environment } from '../environments/environment';
import { metaReducers, reducers } from './reducers';
import { ToastService } from './utils/toast.service';
import { CustomSerializer } from './utils/utils';
@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,

        // Amplify
        AmplifyAngularModule,

        TranslateModule.forRoot(),

        // Markdown
        MarkdownModule.forRoot({ loader: HttpClient }),

        // Material
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        AuthModule,
        MainModule,

        // NGRX
        StoreModule.forRoot(reducers, { metaReducers }),
        !environment.production ? StoreDevtoolsModule.instrument() : [],
        EffectsModule.forRoot([]),
    
        StoreRouterConnectingModule.forRoot({
            stateKey: 'router',
            serializer: CustomSerializer
        })

    ],
    providers: [
        {
            provide: AmplifyService,
            useFactory: () => {
                return AmplifyModules({
                    Auth,
                    Api
                });
            }
        },
        AppSyncErrorService,
        AuthService,
        UserApiService,
        ToastService
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
